// extracted by mini-css-extract-plugin
export default {"question-page":"QuestionPage_question-page__qPCuV","question-title":"QuestionPage_question-title__PDzIW"};